import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-slate-600/30 bg-blue-950 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-76" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-77" data-mp="9t1pfcgekne6">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-amber-400/70 bg-slate-950 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-78" data-mp="euh8iyz0sjtx">
          <span className="inline-flex rounded-full border border-yellow-400/50 bg-blue-950 p-4 text-yellow-400" data-id="element-79" data-mp="sn6yfeho68wb">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-80" data-mp="12ja9xayevjvx" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold uppercase tracking-tight text-stone-50 sm:text-4xl" data-id="element-81" data-mp="17i4p82x66qba">
            7-Day <span className="text-amber-400" data-id="element-82" data-mp="25s6yo9qusz45">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-83" data-mp="20t3sun31uov4">
            Study all 6 diesel engines &amp; generators volumes and 5 bonuses this week. If the technical depth doesn&apos;t
            match your professional needs,{' '}
            <span className="font-extrabold text-amber-400" data-id="element-84" data-mp="1rtqjduexe0ae">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}